import * as Actions from '../actions/switchControls.actions';

const initialState = [];

const switchControls = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_SWITCH_CONTROLS: {
      return action.payload;
    }
    case Actions.ADD_SWITCH_CONTROLS: {
      return [...state, action.payload];
    }
    case Actions.UPDATE_SWITCH_CONTROLS:
    case Actions.GET_SWITCH_CONTROL: {
      const index = state.findIndex(
        (switchControl) => switchControl.id === action.payload.id
      );
      const newState = state;
      newState[index > -1 ? index : state.length] = action.payload;
      return [...newState];
    }
    case Actions.REMOVE_SWITCH_CONTROLS: {
      return state.filter((obj) => obj.id !== action.payload.id);
    }
    default:
      return state;
  }
};

export default switchControls;
